import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { BUILD_ID } from "./lib/buildInfo";

// Force new build hash for every deployment
document.documentElement.setAttribute("data-build", BUILD_ID);

// Error overlay for debugging
function showErrorOverlay(message: string, stack?: string) {
  const root = document.getElementById("root");
  if (!root) return;
  
  root.innerHTML = `
    <div style="position:fixed;inset:0;background:#000;color:#fff;padding:2rem;overflow:auto;font-family:monospace;font-size:14px;z-index:9999">
      <h1 style="color:#ff6b6b;margin-bottom:1rem">Runtime Error</h1>
      <p style="margin-bottom:1rem;color:#ffd700">${message}</p>
      ${stack ? `<pre style="background:#1a1a1a;padding:1rem;border-radius:8px;overflow:auto;color:#ddd">${stack}</pre>` : ''}
      <button onclick="location.reload()" style="margin-top:1rem;padding:0.75rem 1.5rem;background:#D4AF37;color:#000;border:none;border-radius:0.5rem;cursor:pointer;font-weight:600">Reload</button>
    </div>
  `;
}

// Global error handlers
window.addEventListener('error', (event) => {
  console.error('[Global Error]', event.error);
  showErrorOverlay(event.error?.message || 'Unknown error', event.error?.stack);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('[Unhandled Rejection]', event.reason);
  showErrorOverlay(
    event.reason?.message || String(event.reason),
    event.reason?.stack
  );
});

// Safe boot with try/catch
try {
  createRoot(document.getElementById("root")!).render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
} catch (error: any) {
  console.error('[Render Error]', error);
  showErrorOverlay(error?.message || 'Failed to render app', error?.stack);
}
